import React from 'react';
import { useThree, useFrame } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera, CubeCamera, Environment, Lightformer } from "@react-three/drei";
import { Car } from "./Car";

export function CarShow({ isRotating }) {
    const { camera } = useThree();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const radius = 4; // The distance from the car to the camera
    const speed = 0.004; // The speed of the rotation
    let angle = Math.atan2(camera.position.z, camera.position.x); // The initial angle of the camera

    useFrame(() => {
        // Rotate the camera around the car
        if (isRotating) {
            angle += speed;
            camera.position.x = radius * Math.cos(angle);
            camera.position.z = radius * Math.sin(angle);
            camera.lookAt(0, 0, 0); // Make the camera look at the car
        }
    });

    return (
        <>
            <OrbitControls
                enabled={!isRotating}
                enableZoom={isMobile}
                target={[0, 0, 0]}
                maxPolarAngle={1.45}
                maxDistance={isMobile ? 10 : 10}
                minDistance={4.5}
                dampingFactor={0.07}
                enableDamping={true}
                enablePan={false}
            />
            <PerspectiveCamera makeDefault fov={45} position={isMobile ? [15, 1, 9] : [3.2, 1, 1]} />
            <color args={[1, 1, 1]} attach="background" />
            <CubeCamera resolution={16} frames={Infinity}>
                {texture => (
                    <>
                        <Environment resolution={16}>
                            {/* Ceiling */}
                            <Lightformer intensity={3} rotation-x={Math.PI / 2} position={[0, 4, -9]} scale={[100, 1, 1]} />
                            <Lightformer intensity={3} rotation-x={Math.PI / 2} position={[0, 4, -6]} scale={[100, 1, 1]} />
                            <Lightformer intensity={3} rotation-x={Math.PI / 2} position={[0, 4, -3]} scale={[100, 1, 1]} />
                            <Lightformer intensity={3} rotation-x={Math.PI / 2} position={[0, 4, 0]} scale={[100, 1, 1]} />
                            <Lightformer intensity={3} rotation-x={Math.PI / 2} position={[0, 4, 3]} scale={[100, 1, 1]} />
                            <Lightformer intensity={3} rotation-x={Math.PI / 2} position={[0, 4, 6]} scale={[100, 1, 1]} />
                            <Lightformer intensity={3} rotation-x={Math.PI / 2} position={[0, 4, 9]} scale={[100, 1, 1]} />
                            {/* Sides */}
                            <Lightformer intensity={2} rotation-y={Math.PI / 2} position={[-50, 2, 0]} scale={[100, 2, 1]} />
                            <Lightformer intensity={2} rotation-y={-Math.PI / 2} position={[50, 2, 0]} scale={[100, 2, 1]} />
                        </Environment>
                        <Car />
                    </>
                )}
            </CubeCamera>

        </>
    );
}